module.exports = __webpack_public_path__ + "07_mole.9a7a6196.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer2/07_mole.png
// module id = HDdz
// module chunks = 0